<template>
  <div>
    <footer>
      <ul>
        <li @click="home">
          <img class="home" src="@/assets/footer/アセット 14@2x.png" v-if="$route.path === '/home'" width="295" height="319" loding="lazy"/>
          <img class="home" src="@/assets/footer/アセット 17@2x.png" v-else width="295" height="319" loding="lazy"/>
        </li>
        <li @click="mealHistory">
          <img class="meal-history" src="@/assets/footer/アセット 15@2x.png" v-if="$route.path === '/history'" width="360" height="306" loding="lazy"/>
          <img class="meal-history" src="@/assets/footer/アセット 18@2x.png" v-else width="360" height="306" loding="lazy"/>
          </li>
        <li @click="other">
          <img class="other" src="@/assets/footer/アセット 16@2x.png" v-if="$route.path === '/other'" width="271" height="243" loding="lazy"/>
          <img class="other" src="@/assets/footer/アセット 19@2x.png" v-else width="271" height="243" loding="lazy"/>
          </li>
      </ul>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Menu",
  methods: {
    home() {
      this.$router.push("/home");
    },
    mealHistory() {
      this.$router.push({name: 'History', params: {propsSelected: true}});
    },
    other() {
      this.$router.push("/other");
    },
  },
};
</script>

<style scoped>
  @import "../assets/css/footer.css";
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue